import { sleep } from '@/utils/index';
import request from '@/utils/request';
import { IDateRange, ReportAggregationGroupEnum } from './types';

// data type
export namespace get_report {
  export enum ViewOptionEnum {
    UNKNOWN_OPTION = 'UNKNOWN_OPTION',
    VIEW_METRICS_PER_AGENT = 'VIEW_METRICS_PER_AGENT',
    INCLUDE_DOMESTIC_AGENCY = 'INCLUDE_DOMESTIC_AGENCY',
    INCLUDE_DOMESTIC_BUYOUT = 'INCLUDE_DOMESTIC_BUYOUT',
    INCLUDE_EXCHANGE_STATION = 'INCLUDE_EXCHANGE_STATION',
  }

  export enum ColumnFieldEnum {
    UNKNOWN_FIELD = 'UNKNOWN_FIELD',
    YEARLY_TOTAL = 'YEARLY_TOTAL',
    AGGREGATED_TOTAL = 'AGGREGATED_TOTAL',
    UNIT_SALES = 'UNIT_SALES',
    UNIT_ORDERS = 'UNIT_ORDERS',
    UNIT_REFUNDED = 'UNIT_REFUNDED',
    UNIT_CARRYOVER = 'UNIT_CARRYOVER',
    UNIT_STOCK = 'UNIT_STOCK',
    UNIT_REMARK = 'UNIT_REMARK',
    UNIT_PAYMENT_WAITING = 'UNIT_PAYMENT_WAITING',
  }

  export interface Request {
    year: number;
    aggregatedMonthRange?: IDateRange;
    // productIds: string[]; // remove this after product_groups has been supported
    productGroups: ReportAggregationGroupEnum[];
    viewOptions?: ViewOptionEnum[];
    columnFields?: ColumnFieldEnum[];
  }

  export interface Response {
    url: string;
  }
}

// mock
const useMock = process.env.VUE_APP_API_USE_MOCK === 'true';

const mockGetReport = (req: get_report.Request) => {
  return {
    url:
      'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf',
  } as get_report.Response;
};

// api
export const getReport = async (req: get_report.Request) => {
  if (useMock) {
    await sleep(500);
    return mockGetReport(req);
  }

  const res = await request({
    url: '/v1/get-report',
    method: 'post',
    data: req,
  });
  return res.data as get_report.Response;
};
